import bus from "../bus";
import throttle from "lodash.throttle";
import { mastheadPlayerEvents, playerEvents } from "../player/events";
import { mergeStateAction } from "../utilities/hyperapp";

let contentElement;
let mastheadElement;
let mastheadPlayerElement;

export default {
  destroy: () => ({ destroyed: true }),
  onCreate: () => (state, actions) => {
    bus.on(playerEvents.STATUS_CHANGE, actions.onPlayerStatusChange);
    bus.on(mastheadPlayerEvents.WIGGLE, actions.wiggle);
    bus.emit(playerEvents.REQUEST_STATUS);
    mastheadElement = document.querySelector(".masthead");
    mastheadPlayerElement = document.querySelector(".masthead__player-wrapper");
    contentElement = document.querySelector(".layout__content");
    contentElement.addEventListener("scroll", actions.onScroll);
    window.addEventListener("scroll", actions.onScroll);
    window.addEventListener("resize", actions.onScroll);
  },
  onDestroy: () => (state, actions) => {
    bus.removeListener(
      playerEvents.STATUS_CHANGE,
      actions.onPlayerStatusChange
    );
    bus.removeListener(mastheadPlayerEvents.WIGGLE, actions.wiggle);
    contentElement.removeEventListener("scroll", actions.onScroll);
    window.removeEventListener("scroll", actions.onScroll);
    window.removeEventListener("resize", actions.onScroll);
  },
  onPlayerStatusChange: ({
    currentItemPlayerItemID,
    currentItemReady,
    currentItemLive,
    currentItemTitle,
    currentItemSubtitle,
    isOpen,
    status
  }) => mergeStateAction({
    isNull: currentItemPlayerItemID === "playable-null",
    isPlaying: status === "playing",
    isLive: currentItemLive,
    isReady: currentItemReady,
    title: currentItemTitle,
    isOpen,
    subtitle: currentItemSubtitle,
  }),
  onScroll: throttle(
    e => (state, actions) => {
      const target = e.target;
      const scrollTop = target.scrollTop
        ? target.scrollTop
        : window.pageYOffset || document.documentElement.scrollTop;
      let testHeight =
        mastheadElement.offsetTop + mastheadPlayerElement.offsetTop;
      if (mastheadElement.offsetParent) {
        testHeight += mastheadElement.offsetParent.offsetTop;
      }

      const offscreen = testHeight < scrollTop;
      if (offscreen !== state.offscreen) {
        return { ...state, offscreen };
      }
    },
    50,
    { leading: true }
  ),
  setWiggle: ({ wiggle }) => ({ wiggle }),
  wiggle: () => (state, actions) => {
    if (state.wiggleTimer) {
      clearTimeout(state.wiggleTimer);
    }
    return {
      ...state,
      wiggle: true,
      wiggleTimer: setTimeout(() => {
        actions.setWiggle(false);
      }, 1000)
    };
  }
};
